// KYT 模块中文国际化

export default {
  // 菜单
  'menu.kyt': 'KYT',
  'menu.kyt.dashboard': 'KYT 总览',
  'menu.kyt.transactions': '交易列表',
  'menu.kyt.query': '手动查询',

  // Dashboard
  'kyt.dashboard.title': 'KYT 风控总览',
  'kyt.dashboard.subtitle': '实时监控链上交易风险，保障资金安全合规',
  'kyt.dashboard.todayQueries': '今日查询次数',
  'kyt.dashboard.monthQueries': '本月查询次数',
  'kyt.dashboard.lowRiskRatio': '低风险占比',
  'kyt.dashboard.highRiskRatio': '高风险交易',
  'kyt.dashboard.riskDistribution': '风险等级分布',
  'kyt.dashboard.trendChart': '7日查询趋势',
  'kyt.dashboard.highRiskList': '最近高风险交易',
  'kyt.dashboard.viewAll': '查看全部',
  'kyt.dashboard.noHighRisk': '暂无高风险交易',

  // 交易列表
  'kyt.list.title': 'KYT 交易列表',
  'kyt.list.subtitle': '查看所有链上交易的 KYT 风险分析结果',
  'kyt.list.searchPlaceholder': '搜索 TX Hash / Payment ID / 地址',
  'kyt.list.riskLevel': '风险等级',
  'kyt.list.provider': 'Provider',
  'kyt.list.moreFilters': '更多筛选',
  'kyt.list.refresh': '刷新',
  'kyt.list.export': '导出',
  'kyt.list.totalRecords': '共 {total} 条记录',
  'kyt.list.selected': '已选择 {count} 项',
  'kyt.list.cancelSelect': '取消选择',
  'kyt.list.batchExport': '批量导出',

  // 表格列
  'kyt.table.time': '时间',
  'kyt.table.paymentId': 'Payment ID / 商户订单号',
  'kyt.table.txHash': 'TX Hash',
  'kyt.table.depositAddress': '入账地址',
  'kyt.table.amount': '金额',
  'kyt.table.blockchain': '链',
  'kyt.table.riskScore': '风险评分',
  'kyt.table.riskLevel': '风险等级',
  'kyt.table.riskTags': '风险标签',
  'kyt.table.provider': 'Provider',
  'kyt.table.action': '操作',
  'kyt.table.detail': '详情',

  // 详情页
  'kyt.detail.title': '交易风险详情',
  'kyt.detail.backToList': '返回列表',
  'kyt.detail.notFound': '未找到交易记录',
  'kyt.detail.basicInfo': '基础信息',
  'kyt.detail.paymentId': 'Payment ID',
  'kyt.detail.merchantOrderNo': '商户订单号',
  'kyt.detail.transactionTime': '交易时间',
  'kyt.detail.amount': '金额',
  'kyt.detail.blockchain': '区块链',
  'kyt.detail.depositAddress': '入账地址',
  'kyt.detail.addressRiskReport': '地址风险报告',
  'kyt.detail.firstSeen': '首次出现',
  'kyt.detail.lastSeen': '最后活跃',
  'kyt.detail.totalTransactions': '交易次数',
  'kyt.detail.totalReceived': '总接收',
  'kyt.detail.totalSent': '总发送',
  'kyt.detail.riskCategories': '风险类别暴露',
  'kyt.detail.directExposure': '直接',
  'kyt.detail.indirectExposure': '间接',
  'kyt.detail.relatedAddresses': '关联地址',
  'kyt.detail.flowChart': '资金流关系图',
  'kyt.detail.flowChartPlaceholder': '资金流可视化功能开发中...',
  'kyt.detail.riskTags': '风险标签',
  'kyt.detail.queryInfo': '查询信息',
  'kyt.detail.queryTime': '查询时间',
  'kyt.detail.queryStatus': '查询状态',
  'kyt.detail.completed': '已完成',
  'kyt.detail.rawData': 'Provider 原始数据',

  // 查询工具
  'kyt.query.title': 'KYT 手动查询',
  'kyt.query.subtitle': '输入地址或交易哈希，即时获取链上风险分析结果',
  'kyt.query.cardTitle': '链上风险查询',
  'kyt.query.cardDesc': '支持查询以太坊、比特币、波场等多链地址和交易的风险评估',
  'kyt.query.addressQuery': '地址查询',
  'kyt.query.txHashQuery': '交易哈希查询',
  'kyt.query.selectBlockchain': '选择区块链',
  'kyt.query.addressPlaceholder': '请输入钱包地址（例如: 0x...）',
  'kyt.query.txHashPlaceholder': '请输入交易哈希（例如: 0x...）',
  'kyt.query.startQuery': '开始查询',
  'kyt.query.querying': '查询中...',
  'kyt.query.success': '查询成功',
  'kyt.query.failed': '查询失败',
  'kyt.query.history': '最近查询记录',
  'kyt.query.analyzing': '正在分析链上数据...',
  'kyt.query.analyzingHint': '请稍候，正在通过 KYT 服务商进行风险评估',
  'kyt.query.inputRequired': '请输入查询内容',
  'kyt.query.invalidAddress': '请输入有效的地址格式（以 0x 开头）',
  'kyt.query.invalidTxHash': '请输入有效的交易哈希',

  // 风险等级
  'kyt.risk.low': '低风险',
  'kyt.risk.medium': '中风险',
  'kyt.risk.high': '高风险',
  'kyt.risk.critical': '极高风险',
  'kyt.risk.lowDesc': '该地址/交易风险较低，未发现明显的高风险关联。',
  'kyt.risk.mediumDesc': '该地址/交易存在一定风险因素，建议进一步审核。',
  'kyt.risk.highDesc': '该地址/交易存在较高风险，发现可疑关联，请谨慎处理。',
  'kyt.risk.criticalDesc':
    '该地址/交易风险极高，可能涉及制裁、暗网等严重违规行为，强烈建议拒绝交易。',

  // 风险标签
  'kyt.tag.sanctions': '制裁',
  'kyt.tag.darknet': '暗网',
  'kyt.tag.mixer': '混币器',
  'kyt.tag.ransomware': '勒索软件',
  'kyt.tag.scam': '诈骗',
  'kyt.tag.gambling': '赌博',
  'kyt.tag.exchange': '交易所',
  'kyt.tag.defi': 'DeFi',
  'kyt.tag.mining': '矿池',

  // 区块链
  'kyt.blockchain.ethereum': '以太坊',
  'kyt.blockchain.bitcoin': '比特币',
  'kyt.blockchain.tron': '波场',
  'kyt.blockchain.polygon': 'Polygon',
  'kyt.blockchain.bsc': 'BNB Chain',
  'kyt.blockchain.solana': 'Solana',

  // Provider
  'kyt.provider.chainalysis': 'Chainalysis',
  'kyt.provider.merkle_science': 'Merkle Science',
};
